import styled from "styled-components";

export const StyledAnswerRendererContainer = styled.div`
    position: relative;
    width: 100%;
    height: auto;

    .answer-string {
        font-size: 15px;
        color: #1C1E21;
        white-space: pre-wrap;
    }
    
    .ant-table {
        font-size: 13px;
    }

    .mixed-answer-container {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        width: 100%;

        .mixed-answer-item {
            display: flex;
            flex-direction: column;
            gap: 1rem;
            width: 100%;

            .mixed-answer-description {
                font-size: 15px;
                line-height: 1.6;
                color: #1C1E21;

                p {
                    margin: 0.5rem 0;

                    &:first-child {
                        margin-top: 0;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                strong {
                    font-weight: 600;
                }
            }

            .mixed-answer-data {
                width: 100%;
            }
        }
    }

    .answer-suggestions {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        margin-top: 2rem;
        padding-top: 1.5rem;
        border-top: 1px solid #e8e8e8;

        .answer-suggestion-item {
            display: block;
            width: 100%;
            text-align: left;
            padding: 0.875rem 1.25rem;
            background-color: #fafafa;
            border: 1px solid #e8e8e8;
            border-radius: 8px;
            font-size: 13px;
            color: #595959;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
                background-color: #f0f0f0;
                border-color: #1677ff;
                color: #1c1e21;
                transform: translateX(4px);
            }
        }
    }
`;
